/**
 * The projection caveat (Brief LABEL-COMMISSION-PROJECTION, tightened by Brief
 * COPY). Copy only — no timing or payment logic is modelled anywhere; this line
 * simply makes plain to an internal reader that every commission dollar figure
 * is a FORECAST off the quoted fee, not money received. Confirmed by the
 * commission manager: commission is the agreed rate multiplied by the
 * whole-course fee, invoiced per college per semester, paid after census in the
 * following calendar year, and calculated on what the student actually paid
 * (even when paid to the college direct).
 *
 * Brief COPY retired the old COMMISSION_DISCLAIMER ("the earnings formula is
 * provisional and pending confirmation") — the formula is now confirmed, so
 * that claim was removed. This projection warning is the SINGLE notice shown on
 * the earnings screen and is also carried on the earnings API payload's
 * `disclaimer` field. Change the wording here and it changes everywhere; nowhere
 * else may restate it.
 */
export const COMMISSION_PROJECTION_DISCLAIMER =
  'Projected commission — not yet received. These figures are estimated from quoted fees. ' +
  'Commission is paid after census, in the following calendar year, and is calculated on what ' +
  'the student actually pays. Treat this as a forecast, not as earnings.';
